// Alert.tsx

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addTemporaryAlert, removeTemporaryAlert, fetchAlerts } from '../store/apps/alert';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import * as signalR from '@microsoft/signalr';
import authService from '../components/api-authorization/AuthorizeService'
import { AlertState } from "src/types/store/storeTypes"
import { AppDispatch } from '../store';


const GlobalAlert: React.FC = () => {
    const [connection, setConnection] = React.useState<signalR.HubConnection | null>(null);
    const alert = useSelector((state: AlertState) => state.alert);
    const dispatch = useDispatch <AppDispatch>();

    useEffect(() => {
        authService.getAccessToken().then((token) => {
            if (token)
            {
                const newConnection = new signalR.HubConnectionBuilder()
                    .withUrl('/alertHub', {
                        accessTokenFactory: () => token,
                        transport: signalR.HttpTransportType.LongPolling
                    }
                    ) // This URL should match the route configured for your hub
                    .configureLogging(signalR.LogLevel.Debug) // Add this line to enable logging

                    .withAutomaticReconnect()
                    .build();

                setConnection(newConnection);
            }
        });

    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(() => {
                    console.log('Connection started!')
                })
                .catch(err => console.error('Error while starting the connection: ', err));

            connection.on('ReceiveAlert', (message: string) => {
                debugger;
                // Dispatch the alert
                dispatch(addTemporaryAlert({ id: new Date().getTime(), type: 'info', message }));
                dispatch(fetchAlerts());
            });

            return () => {
                connection.off('ReceiveAlert');
            };
        }
    }, [connection, dispatch]);

    useEffect(() => {
        if (alert.tempAlerts.length > 0) {
            const timer = setTimeout(() => {
                dispatch(removeTemporaryAlert(alert.tempAlerts[0].id));
            }, 5000); // Customize the duration of the popup display

            return () => clearTimeout(timer);
        }
    }, [alert.tempAlerts, dispatch]);

    //const sendMessage = async () => {
    //    const message = 'Hello, SMMP!';
    //    try {
    //        await connection?.invoke('SendMessage', message);
    //    } catch (err) {
    //        console.error(err);
    //    }
    //};


    return (
        <>
            {alert.tempAlerts.map((alert) => (
                <Snackbar key={alert.id} open={true} autoHideDuration={5000} onClose={() => dispatch(removeTemporaryAlert(alert.id))}>
                    <Alert onClose={() => dispatch(removeTemporaryAlert(alert.id))} severity={alert.type} variant="filled">
                        {alert.message}
                    </Alert>
                </Snackbar>
            ))}
        </>)
};

export default GlobalAlert;



